import ListItem from "@mui/material/ListItem";
import React from "react";
import {List, ListItemText, Paper, Radio, Typography} from "@mui/material";
import {useStores} from "../../../../stores";
import {CATEGORIZATION_STATUS_LIST} from "../../../../services/classes/JobClasses";

export const DevopsCategorizationStateDiagram: React.FC = () => {
    const {categorizationReviewStore} = useStores();
    const statusDelegate = categorizationReviewStore.statusDelegate;
    const job = statusDelegate.latestCategorizationJob;

    return <Paper className="devops-categorization-state-diagram" style={{marginTop: '10em'}}>
        <List subheader={<Typography variant="h6">Override the job status</Typography>}>
            {CATEGORIZATION_STATUS_LIST.map((status, index) => {
                    const active = job?.current_status.status === status;
                const handleForceStatus = () => {
                    const jobId = job?.id;
                    if (jobId) {
                        categorizationReviewStore.aiJobDelegate.devopsOverrideStatusManager.request({
                            jobId,
                            status,
                        })
                    }
                };
                return <ListItem
                    key={status}
                    secondaryAction={<Radio checked={active} onClick={handleForceStatus} title="Override the status"/>}>
                    <ListItemText primary={status}/>
                    </ListItem>;
                }
            )}
        </List>
    </Paper>;
}
